import type { Severity } from "@/api/types";
import { cn } from "@/lib/utils";

const STYLES: Record<Severity, string> = {
  P1: "bg-severity-p1 text-white",
  P2: "bg-severity-p2 text-white",
  P3: "bg-severity-p3 text-black",
  P4: "bg-severity-p4 text-white",
};

export function SeverityBadge({ value, className }: { value: Severity; className?: string }) {
  return (
    <span
      data-testid="severity-badge"
      data-severity={value}
      className={cn(
        "inline-flex h-6 items-center rounded-md px-2 text-xs font-bold tabular-nums",
        STYLES[value],
        className,
      )}
    >
      {value}
    </span>
  );
}
